import type { DetailedHTMLProps, HTMLAttributes } from "react";

export interface SmallContainerProps extends DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {}

export const SmallContainer = ({ children, className, ...props }: SmallContainerProps) => {
    return (
        <button className={`flex items-center justify-center flex-grow-0 w-12 h-12 ${className}`} {...props}>
            {children}
        </button>
    );
};
